import DynamicRichText from './dynamicRichText';

export default DynamicRichText;
